// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tYmc","fullView":"styles_fullView__2dPB_"};